{
  "actionbar.actions": "Actions",
  "actionbar.actionsAvailable": "Actions disponibles.",
  "actionbar.clearSelection": "Supprimer la sélection",
  "actionbar.selected": "{count, plural, =0 {Aucun élément sélectionné} one {# sélectionné} other {# sélectionnés}}",
  "actionbar.selectedAll": "Toute la sélection",
  "breadcrumbs.more": "Plus d’éléments",
  "button.pending": "En attente",
  "calendar.invalidSelection": "{selectedCount, plural, one {La date sélectionnée est indisponible} other {Les dates sélectionnées sont indisponibles}}.",
  "combobox.noResults": "Aucun résultat",
  "contextualhelp.help": "Aide",
  "contextualhelp.info": "Informations",
  "datepicker.endTime": "Heure de fin",
  "datepicker.startTime": "Heure de début",
  "datepicker.time": "Heure",
  "dialog.alert": "Alerte",
  "dialog.dismiss": "Rejeter",
  "dropzone.replaceMessage": "Déposer le fichier à remplacer",
  "inlinealert.informative": "Informations",
  "inlinealert.negative": "Erreur",
  "inlinealert.notice": "Avertissement",
  "inlinealert.positive": "Succès",
  "label.(optional)": "(facultatif)",
  "label.(required)": "(requis)",
  "menu.moreActions": "Autres actions",
  "menu.unavailable": "Indisponible, développer pour plus de détails",
  "notificationbadge.indicatorOnly": "Nouvelle activité",
  "notificationbadge.plus": "{notifications}+",
  "picker.placeholder": "Sélectionner…",
  "picker.selectedCount": "{count, plural, =0 {Aucun élément sélectionné} one {# élément sélectionné} other {# éléments sélectionnés}}",
  "slider.maximum": "Maximum",
  "slider.minimum": "Minimum",
  "table.cancel": "Annuler",
  "table.drag": "Faire glisser",
  "table.editCell": "Modifier la cellule",
  "table.loading": "Chargement...",
  "table.loadingMore": "Chargement supplémentaire...",
  "table.resizeColumn": "Redimensionner la colonne",
  "table.save": "Enregistrer",
  "table.sortAscending": "Trier par ordre croissant",
  "table.sortDescending": "Trier par ordre décroissant",
  "tag.actions": "Actions",
  "tag.hideButtonLabel": "Afficher moins",
  "tag.noTags": "Aucun",
  "tag.showAllButtonLabel": "Tout afficher ({tagCount, number})",
  "toast.clearAll": "Tout effacer",
  "toast.collapse": "Réduire",
  "toast.showAll": "Tout afficher"
}
